<template>
  <v-container>
    <v-row>
      <v-col cols="12" sm="6" md>
        <p>
          Main DB 👉
          <v-btn text color="green darken-2" v-on:click="exportMainDB('csv')">
            csv
          </v-btn>
          <v-btn text color="green darken-2" v-on:click="exportMainDB('tsv')">
            tsv
          </v-btn>
        </p>
      </v-col>
      <v-col cols="12" sm="6" md>
        <p>
          ทำจดหมาย 👉
          <v-btn text color="green darken-2" v-on:click="exportLetter('csv')">
            csv
          </v-btn>
          <v-btn text color="green darken-2" v-on:click="exportLetter('tsv')">
            tsv
          </v-btn>
        </p>
      </v-col>
      <v-col cols="12" sm="6" md>
        <p>
          PromptPost 👉
          <v-btn
            text
            color="green darken-2"
            v-on:click="exportPromptPost('csv')"
          >
            csv
          </v-btn>
          <v-btn
            text
            color="green darken-2"
            v-on:click="exportPromptPost('tsv')"
          >
            tsv
          </v-btn>
        </p>
      </v-col>
      <v-col cols="12" sm="6" md>
        <p>
          ข้อมูลทั้งหมด 👉
          <v-btn text color="green darken-2" v-on:click="downloadArchive">
            zip
          </v-btn>
        </p>
      </v-col>
    </v-row>
    <v-snackbar v-model="exported" class="text-center">
      Exported! 🎉🎉
    </v-snackbar>
  </v-container>
</template>

<script>
/// <reference path="../../types/cadavers.d.ts" />

import { apiFetch } from "../../api";

function downloadURL(url, filename) {
  const a = document.createElement("a");
  if (filename) {
    a.download = filename;
  } else {
    a.toggleAttribute("download");
  }
  a.href = url;
  a.click();
}

function downloadXSV(xsv, filename, separatorType) {
  const blob = new Blob(["\uFEFF", xsv], { type: `text/${separatorType}` });
  const url = URL.createObjectURL(blob);
  downloadURL(url, filename);
  URL.revokeObjectURL(url);
}

export default {
  name: "ExportData",
  props: ["cadavers", "students", "cadaverOid"],
  data: () => ({
    exported: false
  }),
  methods: {
    exportMainDB(separatorType) {
      const separator = separatorType === "csv" ? "," : "\t";
      function flattenObject(object) {
        const result = {};
        Object.keys(object).forEach(key => {
          const value = object[key];
          if (value === null) {
            result[key] = "(ไม่มีข้อมูล)";
          } else if (Array.isArray(value)) {
            result[key] = value
              .map(item => flattenObject(item))
              .map(item => Object.values(item).join(" "))
              .join("\n");
          } else if (typeof value === "object") {
            const flattened = flattenObject(value);
            Object.keys(flattened).forEach(flattenedKey => {
              result[`${key}.${flattenedKey}`] = flattened[flattenedKey];
            });
          } else {
            result[key] = value;
          }
        });
        return result;
      }

      /** @type Cadavers */
      const cadavers = this.cadavers;
      const cadaversKey = Object.keys(cadavers);
      const headers = [];
      const rows = [];
      cadaversKey.forEach(number => {
        const cadaver = cadavers[number];
        const flattenedObject = flattenObject(cadaver);
        Object.keys(flattenedObject).forEach(key => {
          if (!headers.includes(key)) headers.push(key);
        });
        const rowText = headers
          .map(key => `"${flattenedObject[key] ?? ""}"`)
          .join(separator);
        rows.push(rowText);
      });
      const xsv = headers.join(separator) + "\r\n" + rows.join("\r\n");
      downloadXSV(
        xsv,
        `export-maindb-${this.cadaverOid}.${separatorType}`,
        separatorType
      );
      /* global amplitude */
      amplitude.getInstance().logEvent("admin_export", { type: "maindb" });
      this.exported = true;
    },
    exportLetter(separatorType) {
      const separator = separatorType === "csv" ? "," : "\t";
      /** @type Cadavers */
      const cadavers = this.cadavers;
      // const toFullMonthName = {
      //   "ม.ค.": "มกราคม",
      //   "ก.พ.": "กุมภาพันธ์",
      //   "มี.ค.": "มีนาคม",
      //   "เม.ย.": "เมษายน",
      //   "พ.ค.": "พฤษภาคม",
      //   "มิ.ย.": "มิถุนายน",
      //   "ก.ค.": "กรกฎาคม",
      //   "ส.ค.": "สิงหาคม",
      //   "ก.ย.": "กันยายน",
      //   "ต.ค.": "ตุลาคม",
      //   "พ.ย.": "พฤศจิกายน",
      //   "ธ.ค.": "พฤศจิกายน"
      // };

      function flattenObject(object) {
        const result = {};
        Object.keys(object).forEach(key => {
          const value = object[key];
          if (value === null) {
            result[key] = "(ไม่มีข้อมูล)";
          } else if (typeof value === "object") {
            const flattened = flattenObject(value);
            Object.keys(flattened).forEach(flattenedKey => {
              result[`${key}.${flattenedKey}`] = flattened[flattenedKey];
            });
          } else {
            result[key] = value;
          }
        });
        return result;
      }

      const cadaversKey = Object.keys(cadavers);
      const headers = [];
      const rows = [];
      cadaversKey.forEach(number => {
        const cadaver = cadavers[number];
        /** @type {Student} */
        const student = Object.values(this.students).find(
          student => student.firstContact === cadaver.number
        );
        const rowObject = {
          ...cadaver,
          firstContact: student,
          letterNo: cadaver.number.substr(1)
        };
        const flattenedObject = flattenObject(rowObject);
        Object.keys(flattenedObject).forEach(key => {
          if (!headers.includes(key)) headers.push(key);
        });
        const rowText = headers
          .map(key => `"${flattenedObject[key] ?? ""}"`)
          .join(separator);
        rows.push(rowText);
      });
      const xsv = headers.join(separator) + "\r\n" + rows.join("\r\n");
      downloadXSV(xsv, `export-letter-${this.cadaverOid}.${separatorType}`);
      amplitude.getInstance().logEvent("admin_export", { type: "letter" });
      this.exported = true;
    },
    exportPromptPost(separatorType) {
      const separator = separatorType === "csv" ? "," : "\t";
      /** @type Cadavers */
      const cadavers = this.cadavers;
      const headers = ["Name", "Address", "Post Code", "Telephone", "Remark"];
      const cadaversKey = Object.keys(cadavers);
      let xsv = headers.join(separator);
      cadaversKey.forEach(number => {
        const cadaver = cadavers[number];
        if (cadaver.letter.post) {
          xsv += "\r\n";
          let address = [
            cadaver.address.room ? `ห้อง ${cadaver.address.room}` : "",
            cadaver.address.number
              ? `บ้านเลขที่ ${cadaver.address.number}`
              : "",
            cadaver.address.building
              ? `อาคาร/หมู่บ้าน ${cadaver.address.building}`
              : "",
            cadaver.address.village ? `หมู่ ${cadaver.address.village}` : "",
            cadaver.address.lane ? `ซอย/ตรอก ${cadaver.address.lane}` : "",
            cadaver.address.road ? `ถนน ${cadaver.address.road}` : "",
            cadaver.address.subdistrict
              ? `แขวง/ตำบล ${cadaver.address.subdistrict}`
              : "",
            cadaver.address.district
              ? `เขต/อำเภอ ${cadaver.address.district}`
              : "",
            cadaver.address.province
              ? `จังหวัด ${cadaver.address.province}`
              : "",
            cadaver.address.code ? `รหัสไปรษณีย์ ${cadaver.address.code}` : ""
          ];
          const data = [
            `${cadaver.relative.title}${cadaver.relative.name} ${cadaver.relative.surname}`,
            address.join(" "),
            cadaver.address.code,
            cadaver.tels
              .map(tel => (tel.name ? `${tel.tel} (${tel.name})` : tel.tel))
              .join(" "),
            cadaver.number
          ];
          const line = data.join(separator);
          xsv += line;
        }
      });
      downloadXSV(
        xsv,
        `export-promptpost-${this.cadaverOid}.${separatorType}`,
        separatorType
      );
      amplitude.getInstance().logEvent("admin_export", { type: "promptpost" });
      this.exported = true;
    },
    downloadArchive() {
      apiFetch("/admin", {
        body: {
          archiveLink: true
        }
      })
        .then(res => res.json())
        .then(json => {
          downloadURL(json.archiveLink);
          amplitude.getInstance().logEvent("admin_export", { type: "archive" });
          this.exported = true;
        });
    }
  }
};
</script>
